<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> Svn相关
                </el-breadcrumb-item>
                <el-breadcrumb-item>访问规则</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <div class="handle-box">
                <div class="plugins-tips">
                    <el-input v-model="query.name" placeholder="Filter" @keyup.enter.native="dealData" class="handle-input mr10"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="dealData()">搜索</el-button>
                    <span style="margin-left: 20px; color: #67C23A; font-size: 15px">查询条件："用户名"</span>

                    <el-button type="primary" @click="clearFileContent()" class="clear-but">清理已删除人员</el-button>
                    <el-button type="primary" @click="postFileContent()" class="update-but" :disabled="updateButDisabled">更新规则</el-button>
                </div>
            </div>
            <div>
                
                <div class="drag-box">
                    <div class="drag-box-item projects-item">
                        <div class="item-title">项目</div>
                        <div group="site">
                            <div tag="div" id="projects" class="item-ul">
                                <el-table
                                style="width: 100%"
                                height="560"
                                :data="table.projects.filter(data => !projectNameSearch || data.projectName.toLowerCase().includes(projectNameSearch.toLowerCase())
                                                                                        || data.cnName.toLowerCase().includes(projectNameSearch.toLowerCase()))"
                                v-loading = "roleLoading"
                                empty-text = "暂无分配"
                                highlight-current-row
                                @row-click="left_rowClick"
                                >
                                    <el-table-column prop="projectName">
                                        <template slot="header" slot-scope="scope">
                                            <el-input
                                                :slot="scope"
                                                v-model="projectNameSearch"
                                                size="mini"
                                                placeholder="项目名"
                                            />
                                        </template>
                                    </el-table-column>

                                    <el-table-column width="140px">
                                        <template slot-scope="{row}">
                                            <el-input v-model="row.cnName" @blur="updateNote(row)"/>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                    <div class="drag-box-item">
                        <div class="item-title">人员</div>

                        <div group="site">
                            <div tag="div" id="done" class="item-ul">
                                <el-table
                                style="width: 100%"
                                :data="table.forPersonnel"
                                height="560"
                                stripe
                                empty-text = "暂无数据"
                                @cell-click="right_deletePersonnel"
                                >
                                    <el-table-column prop="username" label="用户名"></el-table-column>
                                    <el-table-column prop="nickName" label="昵称"></el-table-column>
                                    <el-table-column prop="name" width="55" label="">
                                        <template slot="header" slot-scope="scope">
                                            <!-- 弹框, 新增人员 :append-to-body="false"-->
                                            <el-popover
                                                :ref="scope"
                                                placement="right-start"
                                                width="450"
                                                trigger="click"
                                                >
                                                <el-table
                                                    :data="temAddpersonnelData.filter(data => !search || data.username.toLowerCase().includes(search.toLowerCase()))"
                                                    stripe
                                                    height="537">
                                                    <el-table-column width="130" prop="username" label="用户名">
                                                        <template slot="header" slot-scope="scope">
                                                            <el-input
                                                                :slot="scope"
                                                                v-model="search"
                                                                size="mini"
                                                                placeholder="关键字搜索"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="nickName" label="昵称"></el-table-column>
                                                    <el-table-column width="100" prop="projectName" label="加入项目"></el-table-column>
                                                    <el-table-column width="68" label="">
                                                        <template style="cursor: pointer;" slot-scope="scope">
                                                            <div style="cursor: pointer; width: 100%">
                                                                <el-button @click="right_addPersonnel(scope.row)">添加</el-button>
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                                <el-button type="text" @click="addPersonnel()" slot="reference" style="font-size: 25px; cursor: pointer; color: #606266; padding: 0;">
                                                    <i class="el-icon-circle-plus-outline" style="cursor: pointer;"/>
                                                </el-button>
                                            </el-popover>
                                            
                                        </template>
                                        <template style="cursor: pointer;">
                                            <div style="cursor: pointer; width: 100%">
                                                <i class="el-icon-delete" style="font-size: 15px; cursor: pointer;"></i>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                </div>
                <el-button type="text" @click.stop="fileContentShowChange()" style="cursor: pointer; margin-top: 20px; margin-left: 33px">访问规则文本 </el-button>
                <span style="font-size: 9px; margin-left: 25px; color: #e6a23c">提醒：修改【访问规则文本】需要专业人员操作，请谨慎操作避免发生严重影响</span>
            </div>

            <div class="plugins-tips" v-show="fileContentShow">
                <h4>版本库访问规则</h4>
                
                <el-alert
                    style="margin-top: 20px; padding-left: 5px"
                    v-show="showPostWarning"
                    :title="postWarningContent"
                    type="warning"
                    show-icon>
                </el-alert>

                <el-divider></el-divider>
                <el-row style="margin-top: -20px">
                    <el-col :span="24">
                        <div class="grid-content bg-purple-dark">
                            <el-input
                                :readonly= readonly
                                type="textarea"
                                :rows="24"
                                placeholder="请输入内容"
                                v-model="fileContent">
                            </el-input>
                            <div v-show="readonly">
                                <el-button type="primary" @click.stop="readonly = !readonly" style="margin-top: 10px; cursor: pointer">编辑</el-button>
                            </div>
                            <div v-show="!readonly">
                                <el-button type="primary" @click.stop="postFileContent()" style="margin-top: 10px; cursor: pointer">提交</el-button>
                                <el-button @click.stop="readonly = !readonly" style="margin-top: 10px; cursor: pointer">取消</el-button>
                            </div>
                            
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
    
</template>

<script>
import axios from 'axios';
import http from '../../common/Common.vue';
import {
    getAuthorization,
    getCNName,
    getPersonnelInfoList,
    updateAuthorization,
    updateCNName
} from '../../api/svnAPI.js';

export default {
    name: 'svnStatus',
    data() {
        return {
            query: {
                name: '',  //搜索框
            },

            //调用地址
            serviceUrl: '',
            //访问规则文本
            fileContent: '',
            //临时 访问规则文本
            fileContentPer: '',

            roleLoading: false,
            table: {
                personnel: [],    //项目数据
                forPersonnel: [], //单个项目人员
                cnNames: [],      // 表格中文备注
                projects: []      // 表格项目和人员数据
            },
            addPersonnelData: [],    //可新增人员
            temAddpersonnelData: [], //临时 可新增人员
            search: '',         //可新增人员 查询框
            projectNameSearch: '',

            updateButDisabled: false,//更新规则, 点击禁用 知道返回结果后取消禁用
            
            readonly: true,  //文本只读
            fileContentShow: false, //文本框展示

            showPostWarning: false, //提交修改 后警告框展示
            postWarningContent: '', //提交修改　警告信息

            //身份令牌
            sessId: localStorage.getItem(localStorage.getItem('ms_username') + 'sessId'),
            //svn权限角色  svnRole   1.超级管理    2.普通用户   3.系统管理   4.版本库管理   5.Repository管理    6.用户管理
            svnRole : localStorage.getItem('svnRole')
        };
    },
    created() {
        this.serviceUrl = localStorage.getItem(localStorage.getItem("ms_username") + 'ServiceUrl', this.remoteServiceUrl)
        this.sessId = localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')
        this.initData()
    },
    activated() {
        this.svnRole = localStorage.getItem('svnRole')
        this.initData()
    },
    methods: {
        //初始化数据
        initData() {

            // 获取中文备注
            getCNName(null).then(res => {
                if (res.data.code != 200) {
                    this.$message.warning("中文备注获取失败")
                    return
                }
                this.table.cnNames = res.data.data
            })

            // 访问规则文本
            this.roleLoading = true
            let params = {'url': this.serviceUrl, 'sessId': this.sessId}
            if (this.sessId == undefined || this.sessId == '') {
                params = {'url': this.serviceUrl, 'sessId': localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')}
            }
            getAuthorization(params).then(res => {
                if (res.data.code == 200) {
                    this.fileContent = res.data.data.fileContent
                    this.fileContentPer = res.data.data.fileContent
                    this.dealData()

                } else if (res.data.code == 777) {
                    this.$message.error(res.data.message)
                    this.loginDialogVisible = true
                    this.roleLoading = false
                } else {
                    this.$message.error(res.data.message)
                    this.roleLoading = false
                }
            }).catch(err => {
                this.roleLoading = false
            })
            // 全部人员数据
            this.personnelInit()
        },

        // 全部人员数据
        personnelInit() {
            let params = {'url': this.serviceUrl, 'sessId': this.sessId}
            getPersonnelInfoList(params).then(res => {
                //清空缓存
                this.tableData = []
                this.addPersonnelData = []

                if (res.data.code == 200) {
                    //将返回数据分割成数组    ‘['1|admin', 'Super Administrator', 'admin user']  → ['2|TEST', 'TEST1', '描述测试']’
                    let svnPersonnel = res.data.data.data.split('],')
                    let data = ''
                    for (let i = 0; i < svnPersonnel.length; i++) {
                        //将单条数据 转成 数组
                        data = svnPersonnel[i].split(',')
                        //提取 用户名
                        let username = data[0].slice(data[0].indexOf('|') + 1, data[0].lastIndexOf('\''))
                        //提取 昵称
                        let nickName = data[1].slice(data[1].indexOf('\'') + 1, data[1].lastIndexOf('\''))
                        if (nickName.indexOf('(') != -1 && nickName.indexOf(')') == -1) {
                            nickName = nickName + ')'
                        }
                        //存入
                        this.addPersonnelData.push({username: username, nickName: nickName })
                        this.temAddpersonnelData = this.addPersonnelData
                    }
                    //临时数据
                    this.temAddpersonnelData = this.addPersonnelData
                    
                } else if (res.data.code == 777) {
                    this.$message.warning(res.data.message)
                    this.loginDialogVisible = true
                }
            })
        },

        //处理访问规则文本 到 页面表格,
        dealData() {
            this.table.projects = []
            let jsonStr

            let fileContent = this.fileContent.substring(0, this.fileContent.indexOf('[/]'))
            fileContent.trim().split('\n').forEach(line => {
                if (line.indexOf('=') != -1) {
                    // 临时变量
                    let projectName = line.substring(0, line.indexOf('='))
                    let cnName = ''

                    //personnels 结尾如果有逗号, 就清理掉
                    let personnels = line.substring(line.indexOf('=') + 1, line.length)
                    if (personnels.substring(personnels.length - 1, personnels.length) == ',') {
                        personnels = personnels.substring(0, personnels.length - 1)
                    }

                    // 匹配中文备注
                    if (this.table.cnNames != undefined) {
                        this.table.cnNames.forEach(item => {
                            if (item.projectName == projectName) {
                                cnName = item.cnName
                            }
                        })
                    }
                    
                    //拼接数据
                    jsonStr = { 'projectName': projectName, 'cnName': cnName , 'personnels': personnels }
                    this.table.projects.push(jsonStr)
                }
            });
            
            //如果搜索框不为空, 过滤
            if(this.query.name != '' && this.query.name != undefined) {
                this.table.projects = this.table.projects.filter(personnel => {
                    return (personnel.personnels.indexOf(this.query.name) != -1)
                })
            }
            //清空人员表数据
            this.table.forPersonnel = []
            this.roleLoading = false
        },


        /**
         * 修改中文备注
         * @param {*} row
         */
        updateNote(row) {
            let param = {'projectName': row.projectName, 'cnName': row.cnName}
            updateCNName(param).then(res => {
                if (res.data.code != 200) {
                    this.$message.warning('更改备注失败')
                }
            })
        },

        //项目表 row点击事件
        left_rowClick (row) {
            this.table.forPersonnel = []
            // 将获取的数组字符串 分割成 数组
            let personnels = row.personnels.split(',')
            // 遍历 personnels 数组取出 用户名
            for(let i = 0; i < personnels.length; i++) {
                if (personnels[i] == undefined || personnels[i].length == 0) {
                    continue
                }

                let str
                let nickName
                //遍历取出 昵称
                this.addPersonnelData.forEach(item => {
                    if(item.username == personnels[i]) {
                        nickName = item.nickName
                    }
                })
                //拼接JSON字符串
                str = {'projectName': row.projectName, 'username': personnels[i], 'nickName': nickName}
                this.table.forPersonnel = this.table.forPersonnel.concat(str)
            }
        },

        //人员表 弹出新增框， 过滤应显示信息
        addPersonnel() {
            this.temAddpersonnelData = []
            this.temAddpersonnelData = this.addPersonnelData
            if (this.table.forPersonnel !== undefined) {
                this.table.forPersonnel.forEach(item => {
                    //给 可新增人员标记 项目
                    this.temAddpersonnelData.forEach(item2 => {
                        item2.projectName = item.projectName
                    })
                    //过滤掉 已新增人员
                    this.temAddpersonnelData = this.temAddpersonnelData.filter(jtem => {
                        return item.username !== jtem.username
                    })
                })
            }
        },

        //人员表 可新增人员
        right_addPersonnel(userInfo) {
            //更新 人员表格未更新
            this.table.forPersonnel.push({'username': userInfo.username, 'projectName': userInfo.projectName})

            //更新 数据
            this.table.projects.forEach(item => {
                //定位到 项目下
                if (item.projectName === userInfo.projectName) {
                    //刷新前 访问规则文本行
                    let fileContentLine = item.projectName + '=' + item.personnels;

                    //追加新增人员
                    item.personnels = item.personnels.concat(',' + userInfo.username)

                    //刷新表格数据
                    this.left_rowClick(item)
                    //刷新访问规则文本
                    this.fileContent = this.fileContent.replace(fileContentLine, item.projectName + '=' + item.personnels)

                    //从 可新增人员中 去处刚添加的人员
                    this.temAddpersonnelData = this.temAddpersonnelData.filter(jtem => {
                        return jtem.username !== userInfo.username
                    })
                }
            })
        },
        
        //右 cell点击删除,
        right_deletePersonnel (row, column) {
            if (column.label == '') {
                this.$confirm('确定要删除 '+ row.username +' 吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    //遍历数据
                    this.table.projects.forEach(item => {
                        //定位到 一个项目下
                        if (item.projectName === row.projectName) {
                            //刷新前 访问规则文本行
                            let fileContentLine = item.projectName + '=' + item.personnels;
                            
                            //查询 要删除的人员名
                            if (item.personnels.indexOf(',' + row.username) !== -1) {
                                item.personnels = item.personnels.replace(',' + row.username, '')
                            }
                            if (item.personnels.indexOf(row.username + ',') !== -1) {
                                item.personnels = item.personnels.replace(row.username + ',', '')
                            }
                            if (item.personnels.indexOf(row.username) !== -1) {
                                // 解决仅一个用户的情况
                                item.personnels = ''
                            }

                            //刷新表格数据
                            this.left_rowClick(item)
                            //刷新访问规则文本
                            this.fileContent = this.fileContent.replace(fileContentLine, item.projectName + '=' + item.personnels)
                        }
                    })
                }).catch(err=>{})
            }
        },

        //对象数组去重
        unique(arr) {
            const res = new Map();
            return arr.filter((arr) => !res.has(arr.userId) && res.set(arr.userId, 1))
        },

        //访问规则文本按钮
        fileContentShowChange() {
            this.fileContentShow = !this.fileContentShow
            this.readonly = true
        },

        //清理已删除人员
        clearFileContent() {
            //提取访问规则文本中人员
            let fileContent = this.fileContent.substring(0, this.fileContent.indexOf('[/]'))
            let personnel = ''
            //逗号分隔拼接人员
            fileContent.trim().split('\n').forEach(line => {
                if (line.indexOf('=') != -1) {
                    personnel += line.substring(line.indexOf('=') + 1, line.length) + ','
                }
            });
            
            //数据去重, 转成数据
            personnel = Array.from(new Set(personnel.split(',')))

            //更新所有人员信息
            this.personnelInit()
            let allPersonnel = ''
            //将所有账号拼接成字符串
            this.addPersonnelData.forEach(personnel => {
                allPersonnel += personnel.username + ','
            });

            //遍历 Personnel 访问规则人员账号， 判断所有账号中是否存在
            let personnels = []
            for (let i = 0; i < personnel.length; i++) {
                //如果不存在, 就在访问规则名单中剔除
                if (allPersonnel.indexOf(personnel[i]) == -1) {
                    personnels.push(personnel[i])
                }
            }
            // 二次确认删除
            this.$confirm('确定要清理已删除人员吗？', '提示', {
                type: 'warning'
            }).then(() => {
                //清理 personnels 中的人员
                if (personnels != undefined) {
                    for (let i = 0; i < personnels.length; i++) {
                        this.fileContent = this.fileContent.replaceAll(personnels[i], '')
                        this.fileContent = this.fileContent.replaceAll(',,', ',')
                    }
                    //刷新表格数据
                    this.dealData()
                }
            }).catch(err=>{})
        },

        //提交访问规则
        postFileContent() {
            this.updateButDisabled = true
            this.showPostWarning = false  //默认关闭 警告信息框
            if (!this.serviceUrl.endsWith("/")) {
                this.serviceUrl = this.serviceUrl + "/"
            }
            let params = {'fileContent': this.fileContent, 'url': this.serviceUrl, 'sessId': this.sessId}
            updateAuthorization(params).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('提交数据成功')
                    this.readonly = true
                    //更新数据
                    this.initData()

                    //备份数据
                    var file = new File([this.fileContent], '访问规则.txt', {type: 'text/plain;charset=utf-8'});
                    this.upload(file)
                    this.updateButDisabled = false
                } else if (res.data.code == 777) {
                    this.$message.error(res.data.message)
                    this.loginDialogVisible = true
                    this.updateButDisabled = false
                } else if (res.data.code == 716) {
                    this.postWarningContent = res.data.data.warning
                    this.showPostWarning = true
                    this.updateButDisabled = false
                } else {
                    this.$message.error(res.data.message)
                    this.updateButDisabled = false
                }
            }).catch(err => {
                this.updateButDisabled = false
            })
        },

        //备份 访问规则
        upload(file) {
            const formData = new FormData()
            formData.append('userName', localStorage.getItem('ms_username'))
            formData.append('projectId', '0e85ea5ac76a6535bd29859c8bb10f3f')   //访问规则项目ID
            formData.append('isTest', 1)
            formData.append('file', file)
            
            axios.post(http.httpUrl + 'uploadFiles', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': localStorage.getItem('token')
                },
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('备份成功')
                }
            })
        },

    }
};
</script>
<style lang="scss" scoped>

* {
    cursor: default;
}

// 改变css样式
::v-deep.el-table .warning-row {
    background: #F5F7FA;
    &{
        cursor: pointer;
    }
}


.projects-item {
    /* 鼠标悬浮 */
    ::v-deep.el-table--enable-row-hover .el-table__body tr:hover > td {
    //  background-color: #212e3e !important;
        cursor: pointer;
    }

    max-width: 350px;

}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
::v-deep.el-table__body tr.current-row > td{
  background-color: #FAFAFA !important;
  /* color: #f19944; */  /* 设置文字颜色，可以选择不设置 */
}

.container {
    .plugins-tips {
        color: #333333;

        .bg-purple-dark {
            padding-top: 8px;
        }
        .serverStatusContent {
            font-size: 14px;
            font-weight: 600;
            margin-right: 20px;
        }
        //清理人员 和 更新规则
        .update-but, .clear-but {
            cursor: default;
            float: right;
            margin-right: 20px;
        }
    }
}

.handle-box {
    margin-left: 34px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.mr10 {
    margin-right: 10px;
}

.drag-box{
    display: flex;
    user-select: none;
    margin-left: 35px;
}
.drag-box-item {
    flex: 1;
    background-color: #eff1f5;
    margin-right: 16px;
    border-radius: 6px;
    border: 1px #e1e4e8 solid;

    &:nth-child(2) {
        max-width: 500px;
    }

    .all-checkbox {
        font-size: 14px;
        line-height: 1.5;
        color: #24292e;
        font-weight: 600;
    }
}

.item-title{
    padding: 8px 8px 8px 12px;
    font-size: 14px;
    line-height: 1.5;
    color: #24292e;
    font-weight: 600;
}
.item-ul{
    padding: 0 8px 8px;
}
.item-ul::-webkit-scrollbar{
    width: 0;
}
</style>